import React, { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import {
    SiOpenjdk,
    SiSpringboot,
    SiC,
    SiCplusplus,
    SiGo,
    SiHtml5,
    SiCss3,
    SiJavascript,
    SiReact,
    SiPython,
    SiAmazonwebservices,
    SiGnubash,
    SiNodedotjs,
    SiPostgresql,
    SiMongodb,
    SiRedis,
    SiApachekafka,
    SiPostman,
    SiJira,
    SiDocker,
    SiKubernetes,
    SiJenkins,
    SiGit,
    SiGitlab,
    SiGrafana,
    SiFigma,
    SiTravisci,
} from 'react-icons/si'
import HauntedDust from "./HauntedDust";

const Skills = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const isMobile = window.innerWidth <= 640

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)

        return () => clearTimeout(timer)
    }, [])

    return (
        <div className="container cv-builder">
            <HauntedDust />
            <div className="text-zone">
                <div className="skills-header">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={[
                                'T','H','I','N','G','S',' ',
                                'I',"'",'v','e',' ',
                                'W','O','R','K','E','D',' ',
                                'W','I','T','H'
                            ]}
                            idx={10}
                        />
                    </h1>
                    <p>Stuff I can explain on a whiteboard</p>
                </div>
                <div className="skills-grid">
                    {[
                        { icon: <SiOpenjdk />, name: 'Java' },
                        { icon: <SiSpringboot />, name: 'Spring' },
                        { icon: <SiC />, name: 'C' },
                        { icon: <SiCplusplus />, name: 'C++' },
                        { icon: <SiGo />, name: 'Go' },
                        { icon: <SiHtml5 />, name: 'HTML' },
                        { icon: <SiCss3 />, name: 'CSS' },
                        { icon: <SiJavascript />, name: 'JavaScript' },
                        { icon: <SiReact />, name: 'React' },
                        { icon: <SiPython />, name: 'Python' },
                        { icon: <SiAmazonwebservices />, name: 'AWS' },
                        { icon: <SiGnubash />, name: 'Bash' },
                        { icon: <SiNodedotjs />, name: 'Node.js' },
                        { icon: <SiPostgresql />, name: 'PostgreSQL' },
                        { icon: <SiMongodb />, name: 'MongoDB' },
                        { icon: <SiRedis />, name: 'Redis' },
                        { icon: <SiApachekafka />, name: 'Kafka' },
                        { icon: <SiPostman />, name: 'Postman' },
                        { icon: <SiJira />, name: 'Jira' },
                        { icon: <SiDocker />, name: 'Docker' },
                        { icon: <SiKubernetes />, name: 'Kubernetes' },
                        { icon: <SiJenkins />, name: 'Jenkins' },
                        { icon: <SiGit />, name: 'Git' },
                        { icon: <SiGitlab />, name: 'GitLab' },
                        { icon: <SiGrafana />, name: 'Grafana' },
                        { icon: <SiFigma />, name: 'Figma' },
                        { icon: <SiTravisci />, name: 'Travis CI' },
                    ].map((skill, i) => (
                        <div className="skill-card" key={i}>
                            <div className="icon">{skill.icon}</div>
                            <span>{skill.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Skills
